module.exports = __webpack_public_path__ + "static/media/mysql.33767ffb.svg";